var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',[_c('b-row',[_c('b-col',[_c('Form',{attrs:{"handle-submit":_vm.onSendForm,"values":_vm.item,"violations":_vm.violations}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }